import React from "react";
import "./spinner.scss";

const Spinner = ({ visible = false }) => {
  if (!visible) {
    return null;
  }
  return (
    <div className="spinner-container">
      <div className="spinner" />
    </div>
  );
};

export default Spinner;
